import React from "react";
import { useHistory } from "react-router";

import { WSPage } from "@wingspanhq/fe-component-library";
import {
  CustomFieldResourceType,
  InvoiceStatus,
  InvoiceType
} from "@wingspanhq/payments/dist/interfaces";

import { WSQueries } from "../../../../query/WSQuery";
import { useInvoicesFilteredQuery } from "../../../../query/payments/queries";
import { useCustomFieldsAll } from "../../../../query/customFields/queries/useCustomFieldsAll";
import { useUserId } from "../../../../query/hooks/helpers";

import { PayrollLineItemsReportsDashboard } from "./PayrollLineItemsReportDashboard";

export const RoutePayrollLineItemsReport: React.FC = () => {
  const history = useHistory();
  const userId = useUserId();

  const payrollRunsQuery = useInvoicesFilteredQuery({
    "labels.invoiceType": InvoiceType.Payroll,
    clientId: userId,
    status: InvoiceStatus.Paid
  });

  const queryCustomFieldsAll = useCustomFieldsAll({
    resourceType: [
      CustomFieldResourceType.LineItem,
      CustomFieldResourceType.Collaborator
    ]
  });

  return (
    <WSPage
      title="Payroll Line Items"
      breadcrumb={{
        label: "Back",
        onClick() {
          history.push("/member/reports");
        },
        icon: "arrow-left"
      }}
    >
      <WSQueries
        queries={{
          payrollLineItems: payrollRunsQuery,
          customFields: queryCustomFieldsAll
        }}
        component={PayrollLineItemsReportsDashboard}
      />
    </WSPage>
  );
};
